import React, {useState} from 'react'

export default function useSelectionTable() {
  const tableRef = React.createRef()
  const [selection, setSelection] = useState([])
  const [selectAll, setSelectAll] = useState(false)
  const toggleSelection = key => {
    let newSelection = [...selection]
    const keyIndex = newSelection.indexOf(key)
    if (keyIndex >= 0) {
      newSelection = [
        ...newSelection.slice(0, keyIndex),
        ...newSelection.slice(keyIndex + 1),
      ]
    } else {
      newSelection.push(key)
    }
    setSelection(newSelection)
  }
  const toggleAll = () => {
    const newSelectAll = !selectAll
    const selection = []
    if (newSelectAll) {
      const wrappedInstance = tableRef.current
      const currentRecords = wrappedInstance.getResolvedState().sortedData
      currentRecords.forEach(item => {
        selection.push(item._original._id)
      })
    }
    setSelectAll(newSelectAll)
    setSelection(selection)
  }
  const isSelected = key => {
    return selection.includes(key)
  }

  return {
    tableRef,
    selection,
    selectAll,
    toggleSelection,
    toggleAll,
    isSelected,
    setSelection,
  }
}
